module.exports = __webpack_public_path__ + "img/jiQiRen3.cf4c2d58.png";